import { render, staticRenderFns } from "./flaskLoading.vue?vue&type=template&id=5bc4901a&"
import script from "./flaskLoading.vue?vue&type=script&lang=js&"
export * from "./flaskLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports